export default "__VITE_ASSET__D$ZGOXQV__"